"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class GraphqlClient {
    constructor(client) {
        this._encryption = false;
        this._gqlUrl = client.applicationUrl + "/graphql";
        this._jsonApiClient = client._jsonApiClient;
        const encryptionOptions = client.options.payloadEncryption;
        if (encryptionOptions &&
            encryptionOptions.enforcement.includes("GRAPHQL")) {
            this._encryption = true;
        }
    }
    query(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.gqlRequest(payload);
        });
    }
    mutation(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.gqlRequest(payload);
        });
    }
    gqlRequest(payload) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const gqlQuery = payload.query ? payload.query : payload.mutation;
            const gqlData = typeof gqlQuery === "string" ? gqlQuery : gqlQuery.loc.source.body;
            try {
                const res = yield this._jsonApiClient.request("POST", this._gqlUrl, {
                    data: { query: gqlData, variables: payload.variables },
                    encryption: this._encryption,
                    customMimeType: "application/json",
                });
                return res.data.data;
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
}
exports.default = GraphqlClient;
